import { getAlternateLanguages, toHreflang } from '../i18n';
import { getAlternateEventLanguages } from '../event-slugs';
import { SITE_URL } from '../brand';
import type { CountryCode, CalendarEvent } from '../types';

/** Builds a lang-to-URL map for hreflang alternate links on an event page */
export function buildEventHreflangAlternates(event: CalendarEvent): Record<string, string> {
  const alternates = getAlternateEventLanguages(event.id);
  const languages: Record<string, string> = {};

  for (const alt of alternates) {
    languages[toHreflang(alt.lang)] = `${SITE_URL}/${alt.slug}`;
  }

  // x-default points to English version
  const enAlt = alternates.find(a => a.lang === 'en');
  if (enAlt) {
    languages['x-default'] = `${SITE_URL}/${enAlt.slug}`;
  }

  return languages;
}

/** Builds a lang-to-URL map for hreflang alternate links on a country page */
export function buildHreflangAlternates(code: CountryCode): Record<string, string> {
  const alternates = getAlternateLanguages(code);
  const languages: Record<string, string> = {};

  for (const alt of alternates) {
    languages[toHreflang(alt.lang)] = `${SITE_URL}/${alt.slug}`;
  }

  // x-default points to English version
  const enAlt = alternates.find(a => a.lang === 'en');
  if (enAlt) {
    languages['x-default'] = `${SITE_URL}/${enAlt.slug}`;
  }

  return languages;
}
